import { useAudioPlayer } from '../../components/audioPlayer/provider'
import { Link } from 'react-router-dom'
import { Delete, PlayArrow } from '@nine-thirty-five/material-symbols-react/sharp'
import { IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@iziplay/ui-kit'

export function Playlist() {
  const { playId, currentTrack, playlist, removeFromPlaylist } = useAudioPlayer()

  if (playlist.length === 0) {
    return <p>No tracks added to your playlist, go to <Link to="/music">Search page</Link> to find the best 🎵</p>
  }

  return (
    <div className="scrollable" style={{ display: 'flex', flexDirection: 'column' }}>
      <List style={{ flex: 1, overflowY: 'auto' }}>
        {
          playlist.map(track => (
            <ListItem
              key={track.id}
              secondaryAction={
                <IconButton edge="end" aria-label="remove from playlist" onClick={() => removeFromPlaylist(track.id)}>
                  <Delete size={20} />
                </IconButton>
              }
              disablePadding
            >
              <ListItemButton
                onClick={() => {
                  playId(track.id)
                }}
                disabled={track.status !== 'COMPLETED'}
              >
                <ListItemText primary={track.name} secondary={track.status} />
                {currentTrack?.id === track.id && <ListItemIcon><PlayArrow size={24} /></ListItemIcon>}
              </ListItemButton>
            </ListItem>
          ))
        }
      </List>
    </div>
  )
}
